module.exports = __webpack_public_path__ + "0ad4b184dcfcf1248a6aeed1feee108f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-6.png
// module id = 2511
// module chunks = 0